
import LotterySectionTitle from "./LotterySectionTitle.vue";
import { sortByPrizeLevelAndTime } from "./lotteryUtils";

export default {
  name: "LotteryWinningRecords",
  components: {
    LotterySectionTitle,
  },
  props: {
    winners: {
      type: Array,
      default: () => [],
    },
    copy: {
      type: Object,
      required: true,
    },
  },
  computed: {
    recentWinnerList() {
      return sortByPrizeLevelAndTime(this.winners);
    },
    shouldScrollRecords() {
      return this.recentWinnerList.length > 5;
    },
    displayRecordList() {
      const list = this.recentWinnerList;
      return this.shouldScrollRecords ? [...list, ...list] : list;
    },
    recordScrollTrackStyle() {
      if (!this.shouldScrollRecords) {
        return {};
      }

      const duration = Math.max(this.recentWinnerList.length * 2.5, 12);
      return {
        animationDuration: `${duration}s`,
      };
    },
  },
  methods: {
    // 邮箱脱敏展示，避免中奖纪录直接暴露完整邮箱。
    maskEmail(email) {
      if (!email || email.indexOf("@") === -1) {
        return "";
      }
      const [name, domain] = email.split("@");
      return `${name.slice(0, 2)}***@${domain}`;
    },
  },
};
